import { cn } from "../lib/utils";

const STATUS_STYLES = {
  "Draft": "bg-zinc-500/10 text-zinc-300 border-zinc-500/30",
  "Submitted": "bg-blue-500/10 text-blue-300 border-blue-500/30",
  "Pending Review": "bg-amber-500/10 text-amber-300 border-amber-500/30",
  "Need More Info": "bg-orange-500/10 text-orange-300 border-orange-500/40",
  "Confirmed": "bg-emerald-500/10 text-emerald-300 border-emerald-500/30",
  "Updated": "bg-indigo-500/10 text-indigo-300 border-indigo-500/30",
  "Arrived": "bg-cyan-500/10 text-cyan-300 border-cyan-500/30",
  "Departed": "bg-slate-500/10 text-slate-300 border-slate-500/30",
  "Closed": "bg-neutral-800/60 text-neutral-400 border-neutral-700/60",
};

export function StatusBadge({ status, className }) {
  const style = STATUS_STYLES[status] || STATUS_STYLES.Draft;
  return (
    <span
      data-testid={`status-badge-${status?.toLowerCase().replace(/\s+/g, "-")}`}
      className={cn(
        "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold border backdrop-blur-md whitespace-nowrap",
        style,
        className
      )}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current animate-slow-pulse" />
      {status}
    </span>
  );
}
